<template>
  <div>
    <footer>
      <el-row class="footer_l">
        <el-col :span="10" :offset="2">
          <div class="grid-content bg-purple">
            <p>地址：湖北省武汉市江汉区沿江大道民权路一号长江大厦五楼</p>
            <p>Tel电话：027-65389618</p>
            <p>Email电子邮件：server@jingliyun.com</p>
          </div>
        </el-col>
        <el-col :span="10" :offset="2">
          <div class="grid-content bg-purple-light footer_l_b">
            <div class="wx" style="width: 37px;">
              <img src="../assets/微信@2x.png" alt />
            </div>
            <div class="wx1" style="width: 86px;">
              <img src="../assets/wx2x.png" alt />
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: center;">
          <div class="grid-content bg-purple-dark" style="margin-top: 70px;margin-bottom:15px;">
            <img src="../assets/footerlogo.png" alt width="89px" height="34px" />
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="text-align: center;">
          <div
            class="grid-content bg-purple-dark"
            style="font-size: 14px;color:#A09E9E;"
          >九洲云联（武汉）科技有限公司 鄂 ICP备 16018492号 &nbsp;&nbsp;&nbsp;&nbsp; Copyright © 2015-2019 CNC-LINK All Right Reserved.</div>
        </el-col>
      </el-row>
    </footer>

    <!-- 移动端 -->
    <div class="footers">
      <div class="grid-content bg-purple">
        <p>地址：湖北省武汉市江汉区沿江大道民权路一号长江大厦五楼</p>
        <p>Tel电话：027-65389618</p>
        <p>Email电子邮件：server@jingliyun.com</p>
      </div>
      <div class="grid-content bg-purple-light footer_l_b">
          <img src="../assets/微信@2x.png" alt />
          <img src="../assets/wx2x.png" alt />
      </div>
      <div class="grid-content bg-purple-dark" style="margin-top: 70px;margin-bottom:15px;text-align: center;">
        <img src="../assets/footerlogo.png" alt width="89px" height="34px" />
      </div>
      <div class="grid-content bg-purple-dark" style="font-size: 14px;color:#A09E9E;text-align: center;">
        <p>九洲云联（武汉）科技有限公司 鄂 ICP备 16018492号</p>
        <p>Copyright © 2015-2019 CNC-LINK All Right Reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
footer {
  position: relative;
  bottom: 0;
  width: 100%;
  // height: 348px;
  background-color: #383b48;
  color: #fff;
  padding: 80px 150px 20px 150px;
  .footer_l {
    p {
      line-height: 30px;
      font-size: 14px;
    }
  }
  .footer_l_b {
    div {
      float: left;
      margin: 0 20px;
      &:nth-of-type(1) {
        margin: 20px 0;
      }
      &:nth-of-type(3) {
        margin: 20px 0;
      }
      img {
        width: 100%;
        display: block;
      }
    }
  }
}

@media screen and (min-width: 750px) {
  footer {
    display: block;
  }
  .footers {
    display: none;
  }
}

@media screen and (max-width: 750px) {
  footer {
    display: none;
  }
  .footers {
    display: block;
    position: relative;
    bottom: 0;
    width: 100%;
    background-color: #383b48;
    color: #fff;
    padding: 50px 30px;
    p{
      font-size: 12px;
      line-height: 20px;
    }
    .footer_l_b{
      margin-top: 20px;
      overflow: hidden;
      img{
        float: left;
        &:nth-of-type(1){
          margin-right: 25px;
        }
      }
    }
  }
}
</style>